import React, { useEffect, useState } from 'react';
import { renderToString } from 'react-dom/server';
import './index.scss';
import { withRouter } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import {
  MEDICALLY_REVIEWED_BY,
  PRESCRIPTION_CANONICAL,
  WRITTEN_BY
} from '../../constants/defaults';
import RelatedDrugs from '../prescription-2/RelatedDrugs';
import RelatedArticles from '../common/RelatedArticles/index.jsx';
import LeftMenu from '../DrugDetails/LeftMenu';
import Breadcrumb from '../DrugDetails/Breadcrumb';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { BLOCKS, INLINES } from '@contentful/rich-text-types';
import SkipTo from '../common/Tag/SkipTo';
import { fetchRelatedArticles } from '../../services/Api/DrugInfo';
import _, { throttle } from 'lodash';
import RelatedSection from '../common/RelatedSection/index';
import { getLdJson } from './drugDosageLdJson';
import PopularDrugs from '../common/PopularDrugs';
import { GPT_HEAD_DOSAGE_PAGE } from '../../constants/gptHeadTags/dosagePage';
import AdSlot from '../dfp/AdSlot';
import {
  injectHorizontalAds,
  insertVerticalAds
} from '../dfp/DynamicAdsInjection';
import FactCheckModal from '../common/FactCheckModal';
import AuthorProfile from '../common/AuthorProfile/index.js';
import KeyTakeawaysSection from '../common/KeyTakeawaysSection/index.js';
import PublishedDate from '../common/PublishedDate/index.js';
import TableOfContents from '../common/TableOfContnents/index.js';
const { API } = require('../../config/' + process.env.REACT_APP_ENV);

const DrugDosageLayout = props => {
  let data;
  if (typeof window !== 'undefined' && typeof __INITIAL_DATA__ !== 'undefined')
    data = window.__INITIAL_DATA__;
  else data = props.staticContext.data;
  const drugName = props.match.params.drugName;
  const displayName = data && data.drugName;
  const [blogData, setBlogData] = useState([]);
  const contentSSR = JSON.parse(data.content);
  const [content, setContent] = useState(JSON.parse(data.content));
  const items = [
    { to: '/', label: 'Home' },
    { to: `/prescription/${drugName}`, label: `${displayName} Coupons` }
  ];
  const isAdsVisible = API.ALLOW_DOSAGE_PAGE_ADS;

  const renderOptions = links => {
    const entryBlockMap = new Map();
    let linkRendered = false;
    for (const entry of links.entries.block) {
      entryBlockMap.set(entry.sys.id, entry);
    }
    return {
      renderNode: {
        [BLOCKS.EMBEDDED_ENTRY]: node => {
          const entry = entryBlockMap.get(node.data.target.sys.id);
          return (
            <>
              {!linkRendered && data?.isNormalDrug ? (
                <p className="drug-page-link">
                  <a href={`/prescription/${drugName}#dosage`}>
                    {`Check our best ${displayName} prices`}
                  </a>
                </p>
              ) : (
                ''
              )}
              <div
                className="globalTable"
                dangerouslySetInnerHTML={{
                  __html: entry.tableData
                }}
              ></div>
              {!linkRendered && (linkRendered = true)}
            </>
          );
        },
        [BLOCKS.HEADING_2]: node => {
          return (
            <h2 id={_.createIDFromHeader(node?.content[0]?.value)}>
              {node?.content[0]?.value}
            </h2>
          );
        },
        [BLOCKS.HEADING_3]: node => {
          return (
            <h3 id={_.createIDFromHeader(node?.content[0]?.value)}>
              {node?.content[0]?.value}
            </h3>
          );
        },
        [INLINES.HYPERLINK]: node => {
          if (node?.data?.uri.indexOf('singlecare') === -1) {
            return (
              <a href={node?.data?.uri} target={'_blank'} rel="noreferrer">
                {node?.content[0]?.value}
                <span className="externalLink">
                  <img
                    className="externalLinkImg"
                    src={'/content/images/icons/icon-external-link.svg'}
                    height={14}
                    width={14}
                  />
                </span>
              </a>
            );
          } else return <a href={node?.data?.uri}>{node?.content[0]?.value}</a>;
        }
      }
    };
  };
  const handleBottomAdScroll = () => {
    const viewportHeight = window.innerHeight;
    const bottomTriggerElement = document.querySelector('.homepage-footer');
    const anchorDiv = document.getElementById('bottomStickyAd');
    // Check if the user has scrolled at least 1.5 times the height of the viewport
    if (window.scrollY >= 1.5 * viewportHeight) {
      // Check if the footer is visible
      if (bottomTriggerElement.getBoundingClientRect().top <= viewportHeight) {
        // Show the anchor div
        anchorDiv.classList.remove('bottomAdsBanner');
      } else {
        // Hide the anchor div
        anchorDiv.classList.add('bottomAdsBanner');
      }
    } else {
      // Hide the anchor div
      anchorDiv.classList.remove('bottomAdsBanner');
    }
  };

  const onAdSizeMappingLoad = sizeMapping => {
    injectHorizontalAds(
      [
        {
          path: '/22809915073/Singlecare_Dosage-page/dosage-page_in-content-1st',
          id: 'div-gpt-ad-1687379793668-0',
          size: sizeMapping.inContent
        },
        {
          path: '/22809915073/Singlecare_Dosage-page/dosage-page_in-content-2nd',
          id: 'div-gpt-ad-1687379797893-0',
          size: sizeMapping.inContent
        },
        {
          path: '/22809915073/Singlecare_Dosage-page/dosage-page_in-content-3rd',
          id: 'div-gpt-ad-1687379802540-0',
          size: sizeMapping.inContent
        },
        {
          path: '/22809915073/Singlecare_Dosage-page/dosage-page_in-content-4th',
          id: 'div-gpt-ad-1687379807695-0',
          size: sizeMapping.inContent
        },
        {
          path: '/22809915073/Singlecare_Dosage-page/dosage-page_in-content-5th',
          id: 'div-gpt-ad-1687379813035-0',
          size: sizeMapping.inContent
        }
      ],
      '.DescriptionSection',
      '#app',
      250,
      isAdsVisible
    );
    insertVerticalAds(
      [
        {
          path: '/22809915073/Singlecare_Dosage-page/dosage-page_right-hand_1st',
          id: 'div-gpt-ad-1687379817370-0',
          size: sizeMapping.leftRight
        },
        {
          path: '/22809915073/Singlecare_Dosage-page/dosage-page_right-hand_2nd',
          id: 'div-gpt-ad-1687379823304-0',
          size: sizeMapping.leftRight
        },
        {
          path: '/22809915073/Singlecare_Dosage-page/dosage-page_right-hand_3rd',
          id: 'div-gpt-ad-1687379827443-0',
          size: sizeMapping.leftRight
        },
        {
          path: '/22809915073/Singlecare_Dosage-page/dosage-page_right-hand_4th',
          id: 'div-gpt-ad-1687379832610-0',
          size: sizeMapping.leftRight
        },
        {
          path: '/22809915073/Singlecare_Dosage-page/dosage-page_right-hand_5th',
          id: 'div-gpt-ad-1687379840218-0',
          size: sizeMapping.leftRight
        }
      ],
      '.rightAdsBannerContainer',
      '#app',
      600
    );
    insertVerticalAds(
      [
        {
          path: '/22809915073/Singlecare_Dosage-page/dosage-page_left-hand_1st',
          id: 'div-gpt-ad-1707248220098-0',
          size: sizeMapping.leftRight
        },
        {
          path: '/22809915073/Singlecare_Dosage-page/dosage-page_left-hand_2nd',
          id: 'div-gpt-ad-1707257625431-0',
          size: sizeMapping.leftRight
        },
        {
          path: '/22809915073/Singlecare_Dosage-page/dosage-page_left-hand_3rd',
          id: 'div-gpt-ad-1707257691358-0',
          size: sizeMapping.leftRight
        },
        {
          path: '/22809915073/Singlecare_Dosage-page/dosage-page_left-hand_4th',
          id: 'div-gpt-ad-1707257752396-0',
          size: sizeMapping.leftRight
        },
        {
          path: '/22809915073/Singlecare_Dosage-page/dosage-page_left-hand_5th',
          id: 'div-gpt-ad-1707257816234-0',
          size: sizeMapping.leftRight
        }
      ],
      '.leftAdsBannerContainer',
      '#app',
      600
    );
  };

  useEffect(() => {
    const anchorDiv = document.getElementById('bottomStickyAd');
    const viewportHeight = window.innerHeight;
    // Check if the total page is is at least 3X if the viewport height
    if (document.body.scrollHeight >= 3 * viewportHeight) {
      // Show the anchor div
      window.addEventListener('scroll', throttle(handleBottomAdScroll, 250));
      return () => {
        isAdsVisible &&
          window.removeEventListener('scroll', handleBottomAdScroll);
      };
    } else {
      anchorDiv.classList.remove('bottomAdsBanner');
    }
  }, []);

  useEffect(() => {
    if (!_.isEmpty(content)) {
      let strContent = renderToString(
        documentToReactComponents(content.json, renderOptions(content.links))
      );

      if (strContent) {
        let value = strContent.split('<h3>', 2).join('<h3>').length;
        setContent(insert(strContent, "<div id='appPromo'></div>", value));
      }
    }
    fetchRelatedArticles(drugName).then(res => {
      if (res) setBlogData(res.posts);
    });
  }, []);

  useEffect(() => {
    if (typeof document !== 'undefined') {
      let ctaDiv = document.getElementById('cta');
      if (ctaDiv) {
        if (document.getElementById('appPromo')) {
          document
            .getElementById('appPromo')
            .appendChild(document.getElementById('ctaSection'));
        }
      }
    }
    if (typeof content == 'string') {
      const { sizeMapping } = window;
      if (isAdsVisible && typeof sizeMapping !== 'undefined') {
        if (sizeMapping.inContent) {
          onAdSizeMappingLoad(sizeMapping);
        } else {
          const sizeMappingListener = () => {
            if (sizeMapping.inContent) {
              return onAdSizeMappingLoad(sizeMapping);
            }
            return setTimeout(sizeMappingListener, 200);
          };
          sizeMappingListener();
        }
      }
    }
  }, [content]);

  const insert = (mainString, insString, pos) => {
    if (typeof pos == 'undefined') {
      pos = 0;
    }
    if (typeof insString == 'undefined') {
      insString = '';
    }
    return mainString.slice(0, pos) + insString + mainString.slice(pos);
  };

  const getMetaData = () => {
    return (
      <Helmet>
        <title>{data && data.metaTitle}</title>
        <link
          rel="canonical"
          href={`${PRESCRIPTION_CANONICAL}${drugName}/dosage`}
        />
        <meta name="description" content={data && data.metaDescription} />
        <script type="application/ld+json">{getLdJson(data)}</script>
        <meta property="seo_name" content={drugName} />
        <meta property="placement_name" content="dosage_page" />
        {isAdsVisible && (
          <script async rel="preload">
            {GPT_HEAD_DOSAGE_PAGE}
          </script>
        )}
      </Helmet>
    );
  };
  const displayAuthorProfile = (
    title = '',
    authorData = {},
    withDiscription
  ) => (
    <>
      {authorData?.name && (
        <AuthorProfile
          authorTitle={title}
          authorProfileLink={authorData?.reviewerPageOnSingleCare}
          authorDes={authorData?.title}
          authorName={authorData?.name}
          authorQualifications={authorData?.qualifications}
          authorImg={authorData?.photo}
          description={
            withDiscription &&
            documentToReactComponents(JSON.parse(authorData?.biography || null))
          }
          className="userDataInfo"
        />
      )}
    </>
  );

  return (
    <div className="dosageDetailsMain">
      {getMetaData()}
      <div className="fixedactionButton">
        <div className="stickyLeftNav mobile-tablel">
          <LeftMenu
            sectionList={[]}
            visibleSection={'dosage'}
            seoName={drugName}
            drugSectionList={
              data?.isNormalDrug
                ? ['Coupon/Prices', 'Price History', 'FAQs', 'News & Research']
                : !_.isEmpty(blogData)
                ? ['News & Research']
                : []
            }
            isFromDosage={true}
            whatIsIndex={(data && data?.whatIsIndex) || false}
          />
        </div>
      </div>
      <section className="homepage-new dosageDetailsContent">
        <section className="desktop-only">
          <div className="stickyLeftNav">
            <LeftMenu
              sectionList={[]}
              visibleSection={'dosage'}
              seoName={drugName}
              drugSectionList={
                data?.isNormalDrug
                  ? [
                      'Coupon/Prices',
                      'Price History',
                      'FAQs',
                      'News & Research'
                    ]
                  : !_.isEmpty(blogData)
                  ? ['News & Research']
                  : []
              }
              isFromDosage={true}
              sideEffectSlug={(data && data?.sideEffectSlug) || ''}
              whatIsIndex={(data && data?.whatIsIndex) || false}
            />
          </div>
        </section>

        <section className="contentDescription mobile-section">
          <div className="topBannerAds">
            <div className="adsInTopCenter">
              <AdSlot
                id="div-gpt-ad-1687379789331-0"
                featureDisplayAdsFlag={isAdsVisible}
              />
            </div>
          </div>
          <section className="mainAllSection">
            <div className="leftAdsBannerContainer"></div>
            <section>
              <Breadcrumb
                items={items}
                ariaLabel={`Navigation menu for ${displayName} Dosage`}
              >
                {items.map(({ to, label }) => (
                  <a key={label} href={to}>
                    {label}
                  </a>
                ))}
                <span>{`${displayName} Dosage`}</span>
              </Breadcrumb>

              <section className="DescriptionSection mobile-section">
                <SkipTo>
                  <h1>{data && data.name} </h1>
                </SkipTo>
                {data && (
                  <div
                    className={`${
                      !_.isEmpty(data && data?.tableOfContents)
                        ? 'updateBottomMargin'
                        : ''
                    }`}
                  >
                    <div className="authorLists topLists">
                      <>
                        {!_.isEmpty(data?.medicalReviewer) &&
                          displayAuthorProfile(
                            MEDICALLY_REVIEWED_BY,
                            data?.medicalReviewer,
                            false
                          )}
                        {!_.isEmpty(data?.author) &&
                          displayAuthorProfile(WRITTEN_BY, data?.author, false)}
                      </>
                    </div>
                    <PublishedDate
                      publishedAt={data?.publishedAt}
                      updatedAt={data?.lastUpdatedDate}
                    >
                      {(data?.medicalReviewer || data?.author) && (
                        <FactCheckModal />
                      )}
                    </PublishedDate>
                  </div>
                )}
                {!_.isEmpty(data && data?.tableOfContents) && (
                  <section>
                    <TableOfContents content={data?.tableOfContents} />
                  </section>
                )}
                {!_.isEmpty(data && data?.keyTakeaways) && (
                  <KeyTakeawaysSection
                    keyTakeaways={JSON.parse(data?.keyTakeaways)}
                  />
                )}
                {typeof window === 'undefined' ? (
                  <div>
                    {documentToReactComponents(
                      contentSSR.json,
                      renderOptions(contentSSR.links)
                    )}
                  </div>
                ) : (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: content
                    }}
                  ></div>
                )}

                <div className="bottomUserDataInfo bottomInfo">
                  {data && (
                    <div className="authorLists">
                      <>
                        {!_.isEmpty(data?.medicalReviewer) &&
                          displayAuthorProfile(
                            MEDICALLY_REVIEWED_BY,
                            data?.medicalReviewer,
                            true
                          )}
                        {!_.isEmpty(data?.author) &&
                          displayAuthorProfile(WRITTEN_BY, data?.author, true)}
                      </>
                    </div>
                  )}
                </div>

                <section
                  id="related-drugs"
                  className="relatedDrugs mobile-section"
                >
                  {!_.isEmpty(data && data.linkedDrugs) && (
                    <RelatedDrugs
                      relatedDrugs={data && data.linkedDrugs}
                      isWhatIs={false}
                      isFromCms={true}
                    />
                  )}
                </section>
                {!_.isEmpty(data && data.relatedDosageGuides) && (
                  <section
                    id="related-drugs"
                    className="relatedDrugs mobile-section"
                  >
                    <section className="top-drugs">
                      <article>
                        <h4 className="top-drugs-heading">{`Related dosage guides`}</h4>
                        <ul>
                          {data &&
                            data.relatedDosageGuides.map((item, id) => {
                              return (
                                <li key={id}>
                                  <a href={`/prescription/${item.slug}/dosage`}>
                                    {item.name}
                                  </a>
                                </li>
                              );
                            })}
                        </ul>
                      </article>
                    </section>
                  </section>
                )}
                {!_.isEmpty(data && data.relatedConditions) && (
                  <RelatedSection
                    heading="Related Conditions"
                    slugPrefix="/conditions"
                    isLimited={true}
                    relatedData={data && data.relatedConditions}
                  />
                )}

                <section id="research" className="mobile-section">
                  {!_.isEmpty(blogData) && (
                    <RelatedArticles
                      blogData={blogData}
                      drugName={displayName}
                    />
                  )}
                </section>
                {!_.isEmpty(
                  data && data.popularDrugs && data.popularDrugs.drugs
                ) && (
                  <PopularDrugs
                    popularDrugs={data.popularDrugs.drugs}
                    text="coupons"
                  />
                )}
              </section>
            </section>
            <div className="rightAdsBannerContainer"></div>
          </section>
          <div className="adsInTopCenter">
            <AdSlot
              id="div-gpt-ad-1687379850728-0"
              className="marginBottom-20"
              featureDisplayAdsFlag={isAdsVisible}
            />
          </div>
        </section>
      </section>
      <div id="bottomStickyAd" className="bottomLastAds">
        <AdSlot
          id="div-gpt-ad-1687379857123-0"
          enableCloseBtn={true}
          innerDivClassName="p-1"
          featureDisplayAdsFlag={isAdsVisible}
        />
      </div>
    </div>
  );
};

export default withRouter(DrugDosageLayout);
